module.exports = __webpack_public_path__ + "static/img/icon_hide_not_fly.117e4332.svg";